function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Kettle"
}, /*#__PURE__*/React.createElement("title", null, "VF_kettle_rgb"), /*#__PURE__*/React.createElement("path", {
  d: "M283.5 283.5c0-63.4-27-118-78-142.4V49.6H78v91.5c-9.7 4.6-18.8 10.5-27 17.4l-19.7-19.7-20 20 20.3 20.3C10.8 206.8 0 243.4 0 283.5h283.5zM106.3 78h70.9v53.4c-23.4-5.1-47.5-5.1-70.9 0V78zM57.9 191.6c9.4-11.1 21.1-20 34.4-25.9 14.5-6.5 31.1-9.8 49.4-9.8s34.9 3.3 49.4 9.8c13.3 5.9 25 14.8 34.4 25.9 14 16.5 23.4 38.5 27.4 63.6H30.5c4-25.1 13.4-47.1 27.4-63.6z"
}))));